const React = require("react");

function ArrowSmLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  }));
}

module.exports = ArrowSmLeftIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ArrowSmLeftIcon.js
 ** module id = 443
 ** module chunks = 0
 **/